import React, { useState } from "react";
import { Form, Input, message, Modal } from "antd";
import { logger } from "../../../../../utils";
import I18n from "../../../../i18n";
import { ServiceLocater, Services } from "../../../../../service-locater";
import { ProductsRepository } from "../../../../../domain";

const { useForm, Item } = Form;

type SetPriceModalProps = {
  visible: boolean;
  onClose: (refresh: boolean) => void;
  productId?: string;
};

const SetPriceModal: React.FC<SetPriceModalProps> = ({
  visible,
  onClose,
  productId,
}) => {
  const [form] = useForm();
  const [isLoading, setIsLoading] = useState(false);

  const submit = async () => {
    try {
      await form.validateFields();
      if (productId === undefined) return;
      setIsLoading(true);
      const res = await ServiceLocater.get<ProductsRepository>(
        Services.ProductsRepository
      ).setProductAttributesPrice(productId, form.getFieldValue("price"));
      setIsLoading(false);
      res.fold(
        (_) => {
          message.error(I18n.general.networkError);
        },
        (_) => {
          message.success("قیمت همه ویژگی ها با موفقیت ویرایش شد");
          onClose(true);
        }
      );
    } catch (error) {
      logger.error(error);
    }
  };

  return (
    <Modal
      visible={visible}
      confirmLoading={isLoading}
      onCancel={() => onClose(false)}
      onOk={submit}
      bodyStyle={{ paddingBottom: 0 }}
      destroyOnClose
    >
      <Form form={form}>
        <Item
          name="price"
          label={I18n.product.price}
          required
          rules={[
            { required: true, validateTrigger: "onSubmit", type: "integer" },
          ]}
        >
          <Input
            name="price"
            onChange={(event) => {
              form.setFields([
                { name: "price", value: parseInt(event.target.value) },
              ]);
            }}
          />
        </Item>
      </Form>
    </Modal>
  );
};

export default SetPriceModal;
